import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"float":"left"} }
const _hoisted_3 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":".8rem"} }
const _hoisted_4 = { style: {"float":"left"} }
const _hoisted_5 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":".8rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_catalog_picker_component = _resolveComponent("catalog-picker-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_catalog_picker_component, {
      disabled: _ctx.disabled,
      auth: "",
      modelValue: _ctx.selectedVehicle,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedVehicle) = $event)),
      placeholder: _ctx.placeholder ? _ctx.placeholder : 'Поиск автомобилей по марке, модели, VIN',
      "search-url": "/api/vehicles/search",
      "emit-change-event": "",
      "show-suffix": true,
      "suffix-icon": _ctx.filterIcon,
      onChange: _ctx.onSelectChange
    }, {
      label: _withCtx(() => [
        (_ctx.selectedVehicle?.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(`${_ctx.selectedVehicle.model?.manufacturer?.name} ${_ctx.selectedVehicle.model?.name}`), 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.selectedVehicle.vin), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx((scope) => [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_4, [
            _createTextVNode(_toDisplayString(scope.model?.manufacturer?.name) + " " + _toDisplayString(scope.model?.name) + " ", 1),
            _createVNode(_component_el_text, {
              size: "small",
              type: "info"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.counterparty.lastname) + " " + _toDisplayString(scope.counterparty.firstname), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(scope.vin), 1)
        ])
      ]),
      _: 1
    }, 8, ["disabled", "modelValue", "placeholder", "suffix-icon", "onChange"])
  ]))
}